import React from 'react'
import { useGetPhoneSystemHuntGroupsQuery } from 'src/generated/graphql'
import LoadingOverlay from 'components/Loading/LoadingOverlay'

export const HuntGroupDisplay = ({ node, flow }) => {
  const phoneSystemHuntGroups = useGetPhoneSystemHuntGroupsQuery({
    variables: {
      phoneSystemId: flow.phoneSystemId,
    },
  })

  const huntGroupInfo = phoneSystemHuntGroups.data?.phoneSystemHuntGroups.find(
    item => item.id === node.extras.huntGroupId
  )

  return (
    <div>
      {huntGroupInfo?.customerReference}
      {phoneSystemHuntGroups.loading && <LoadingOverlay />}
    </div>
  )
}



// WEBPACK FOOTER //
// src/features/Flows/Flow/Nodes/HuntGroup/HuntGroupDisplay.tsx